import { render, staticRenderFns } from "./SalesRevenueSummaryList.vue?vue&type=template&id=3ec23462&scoped=true"
import script from "./SalesRevenueSummaryList.vue?vue&type=script&lang=js"
export * from "./SalesRevenueSummaryList.vue?vue&type=script&lang=js"
import style0 from "./SalesRevenueSummaryList.vue?vue&type=style&index=0&id=3ec23462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec23462",
  null
  
)

export default component.exports